import { adminAPIService, adminFileDownloadService } from './index'

const route = 'reports'

export const getDailySales = (year, month) => {
  const params = {
    year,
    month,
  }

  return adminAPIService({
    url: `${route}/daily-sales`,
    method: 'get',
    params,
  })
}

export const downloadMonthlyGMV = (year, month) => {
  const params = {
    year,
    month,
  }

  return adminFileDownloadService({
    url: `${route}/monthly-gmv`,
    method: 'get',
    headers: {
      'Content-Type': 'text/csv',
    },
    data: {}, // https://github.com/axios/axios/issues/86#issuecomment-139638284
    params,
  })
}

export const getAdPerformance = (startDate, endDate) => {
  const params = {
    start_date: startDate,
    end_date: endDate,
  }

  return adminAPIService({
    url: `${route}/ad-performance`,
    method: 'get',
    params,
  })
}

export const generateSalesCSV = ({
  startDate,
  endDate,
  affiliate,
  advertiser_id,
  marketing_u1,
}) => {
  const params = {
    start_date: startDate,
    end_date: endDate,
    affiliate: affiliate,
    advertiser_id: advertiser_id,
    marketing_u1: marketing_u1,
  }

  return adminAPIService({
    url: `${route}/sales-performance`,
    method: 'get',
    params,
  })
}

export const generatePrivateClientSalesCSV = ({
  startDate,
  endDate,
}) => {
  const params = {
    start_date: startDate,
    end_date: endDate,
    ts: Date.now()
  }

  return adminAPIService({
    url: `${route}/private-client-sales`,
    method: 'get',
    params,
  })
}

export const generateRsSalesCSV = () => {
  const params = {
  }
  return adminFileDownloadService({
    url: `${route}/kol-sales`,
    method: 'get',
    headers: {
      'Content-Type': 'text/csv',
    },
    data: {}, // https://github.com/axios/axios/issues/86#issuecomment-139638284
    params,
  })
}

export const generateRsPayoutsCSV = () => {
  const params = {
  }
  return adminFileDownloadService({
    url: `${route}/kol-payouts`,
    method: 'get',
    headers: {
      'Content-Type': 'text/csv',
    },
    data: {}, // https://github.com/axios/axios/issues/86#issuecomment-139638284
    params,
  })
}

export const generateMpDeliveriesCSV = () => {
  const params = {
  }
  return adminFileDownloadService({
    url: `${route}/mp-deliveries`,
    method: 'get',
    headers: {
      'Content-Type': 'text/csv',
    },
    data: {}, // https://github.com/axios/axios/issues/86#issuecomment-139638284
    params,
  })
}
